import { Icon } from '@graftcode/design-system'

import { SettingsCategory } from '../enums'
import type { SettingsNavCategory } from '../types'

export const SETTINGS_NAV_ITEMS: SettingsNavCategory[] = [
  {
    id: SettingsCategory.ACCOUNT,
    label: 'Account',
    items: [
      { id: 'account-general', label: 'General', icon: Icon.SettingsRegular, url: 'settings' },
      {
        id: 'account-your-workspaces',
        label: 'Your workspaces',
        icon: Icon.OrganizationRegular,
        url: 'settings/your-workspaces',
      },
    ],
  },
  {
    id: SettingsCategory.WORKSPACE,
    label: 'Workspace',
    items: [
      { id: 'workspace-general', label: 'General', icon: Icon.SettingsRegular, url: 'settings/workspace' },
      {
        id: 'workspace-members',
        label: 'Members',
        icon: Icon.PeopleRegular,
        url: 'settings/workspace/members',
      },
      {
        id: 'workspace-notifications',
        label: 'Notifications settings',
        icon: Icon.AlertRegular,
        url: 'settings/workspace/notifications',
        disabled: true,
      },
    ],
  },
  {
    id: SettingsCategory.PROJECT,
    label: 'Project',
    items: [
      { id: 'project-general', label: 'General', icon: Icon.SettingsRegular, url: 'settings/project' },
      {
        id: 'project-members',
        label: 'Members',
        icon: Icon.PeopleRegular,
        url: 'settings/project/members',
      },
      {
        id: 'project-artifact-feeds',
        label: 'Artifact feeds',
        icon: Icon.FolderRegular,
        url: 'settings/project/artifact-feeds',
        disabled: true,
      },
      {
        id: 'project-activity-log',
        label: 'Activity log',
        icon: Icon.HistoryRegular,
        url: 'settings/project/activity-log',
        disabled: true,
      },
      { id: 'project-plans', label: 'Plans', icon: Icon.PaymentRegular, url: 'settings/project/plans', disabled: true },
    ],
  },
]
